import React from "react";

function Intro() {
  return (
    <section className="page-banner">
      <div className="container">
        <div className="page-content-wrapper">
          <div className="page-badge">NetZero</div>
          <h1 className="page-title">
            Manage your Net Zero journey effortlessly
          </h1>
          <p className="page-description">
            Measure, reduce, offset and report your carbon emission seamlessly
            and <br /> make faster progress in your decarbonisation journey.{" "}
          </p>
        </div>
      </div>
    </section>
  );
}

export default Intro;
